import { isSome } from './maybe';
export const currencies = [
    'AED',
    'ALL',
    'AMD',
    'AZN',
    'BAM',
    'BGN',
    'BHD',
    'CAD',
    'CZK',
    'DKK',
    'DZD',
    'EGP',
    'EUR',
    'GBP',
    'GEL',
    'HUF',
    'CHF',
    'ILS',
    'INR',
    'IQD',
    'IRR',
    'ISK',
    'JOD',
    'KWD',
    'LBP',
    'LEV',
    'LYD',
    'MAD',
    'MDL',
    'MRO',
    'NOK',
    'OMR',
    'PLN',
    'QAR',
    'RON',
    'RSD',
    'SAR',
    'SDG',
    'SEK',
    'SYP',
    'TND',
    'TRY',
    'UAH',
    'USD',
    'YER',
];
export const CURRENCIES = currencies;
export const CurrencyEnum = currencies.reduce((acc, c) => {
    acc[c] = c;
    return acc;
}, {});
export function getCurrencyItems() {
    const options = currencies.map((type) => ({
        value: type,
        label: type,
    }));
    options.unshift({
        value: '',
        label: '(none)',
    });
    return options;
}
export function getCurrencySelectOptions(props) {
    return currencies.map((type) => ({
        value: type,
        label: type,
        backgroundColor: props === null || props === void 0 ? void 0 : props.backgroundColor,
    }));
}
export function convertCurrency(value, currency, conversion) {
    var _a, _b;
    const conversionRate = isSome(currency) && isSome(conversion) ? ((_b = (_a = conversion.exchRates) === null || _a === void 0 ? void 0 : _a[currency]) !== null && _b !== void 0 ? _b : undefined) : undefined;
    const exchangeRate = isSome(conversionRate) && isSome(conversion === null || conversion === void 0 ? void 0 : conversion.targetCurrency) ? conversionRate : 1;
    return (value !== null && value !== void 0 ? value : 0) * exchangeRate;
}
//# sourceMappingURL=currency.js.map